module.exports = __webpack_public_path__ + "static/media/facebook.1450a0b1.svg";